export const validation = {
  titleMaxChar: 120,
  paragraphMaxChar: 1500,
  portfolioImages: {
    min: 3,
    max: 30
  }
}
